import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class SportelliService {

    static urlSportelli = globals["app-url-backend-sportelli"]

    static getSportelli(params) {
        return axios.get(this.urlSportelli + Utils.addQueryParamsToRequestUrl(params))
    }

    static inserisciSportello(jsonInsert) {
        return axios.post(this.urlSportelli +"/nuovo", jsonInsert)
    }

    static modificaSportello(id,jsonInsert) {
        return axios.put(this.urlSportelli + "/"+id, jsonInsert)
    }

    static eliminaSportello(id) {
        return axios.delete(this.urlSportelli +"/"+id)
    }

}
